import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import AdminSidebar from '../../components/AdminSidebar';
import api from '../../config/api';
import toast from 'react-hot-toast';

const AdminContentPrivacy = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/content/privacy');
      if (response.data.success) {
        setContent(response.data.content || '');
      }
    } catch (error) {
      // If content doesn't exist, start with empty
      setContent('');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const response = await api.post('/admin/content/privacy', { content });
      if (response.data.success) {
        toast.success('Privacy Policy updated successfully');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to save privacy policy');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminSidebar>
        <div className="flex items-center justify-center py-16">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
        </div>
      </AdminSidebar>
    );
  }

  return (
    <AdminSidebar>
      <div className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-1 sm:mb-2">
            Privacy Policy
          </h1>
          <p className="text-sm sm:text-base text-gray-600">Manage privacy policy content for the frontend</p>
        </div>
        <button
          onClick={handleSave}
          disabled={saving}
          className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg disabled:opacity-60"
        >
          <Save className="h-5 w-5" />
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Privacy Policy Content (HTML supported)
          </label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-purple-500 focus:outline-none font-mono text-sm"
            rows="30"
            placeholder="Enter privacy policy content here. HTML is supported..."
          />
        </div>
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
          <p className="text-sm text-purple-700">
            <strong>Note:</strong> This content will be displayed on the frontend Privacy Policy page. 
            You can use HTML tags for formatting. Changes will be reflected immediately after saving.
          </p>
        </div>
      </div>
    </AdminSidebar>
  );
};

export default AdminContentPrivacy;

